/*
 * @Author: tao.zong
 * @Date: 2018-12-14 11:30:14
 * @Last Modified by: tao.zong
 * @Last Modified time: 2018-12-15 11:45:14
 * @webview 4.0.0以上版本，ios注册通知内容，杀掉app的时候，系统帮发消息
 */
import backgroundCheckinNotiHandler from "@/components/notification/checkNotice";
import store from "@/store";
import * as types from "@/store/constants/types";

const randomIcon = (arr: any) => {
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
};
let timetest = 0;
class GetNoticeContent {
  private noticeData = "";
  private levelNotification: any;
  //总的权重
  private totalWeight: number = 0;
  private LimitCoinsNotice = [
    {
      title: "💰 4X Value Coins💰",
      text: "Here comes the chance! 🔔 ",
      icon: "limited_noti_1_80",
      customData: { type: "limit-coin-notice" }
    }
  ];
  private luckyCoinIcon = ["lucky_noti_1_80", "lucky_noti_2_80"];
  private LuckyCoinsNotice = [
    {
      title: "💰 Win 1,000,000 Coins 💰",
      text: "Lucky Offer is here! Get it right Now!",
      icon: randomIcon(this.luckyCoinIcon),
      customData: { type: "lucky-coin-notice" }
    }
  ];
  private earnCoinsNotice = [
    {
      title: "FREE FOLLOWERS Coming Soon🎉",
      text: "Hurry, use FREE COINS to get your followers or likes.😍",
      icon: "vip_noti_4_80",
      customData: { type: "earn-coin-notice" }
    }
  ];
  //池子里需要随机发送的消息   luckycoin权重为30，earn coin权重为20 limit coin权重为40（不需要判断，直接在池子里）
  private needRandomNoticeList: any = [
    {
      notice: this.LuckyCoinsNotice,
      weight: 30
    },
    {
      notice: this.earnCoinsNotice,
      weight: 20
    },
    {
      notice: this.LimitCoinsNotice,
      weight: 40
    }
  ];
  public calcNoticeData = () => {
    //签到的通知
    const data1 = backgroundCheckinNotiHandler.configNotification();
    //注册coin的消息
    const data2 = this.getCoinNotice();
    // return JSON.stringify({
    //   title: "💰 Win 1,000,000 Coins 💰",
    //   content: "Lucky Offer is here! Get it right Now!",
    //   customData: { type: "lucky-coin-notice" },
    //   timeInterval: 5000,
    //   imageUrl: "vip_noti_4_80"
    // });
    return (data1 + data2).substr(1);
  };

  private getCoinNotice = () => {
    timetest = 0;
    this.needRandomNoticeList = [
      {
        notice: this.LuckyCoinsNotice,
        weight: 30
      },
      {
        notice: this.earnCoinsNotice,
        weight: 20
      },
      {
        notice: this.LimitCoinsNotice,
        weight: 40
      }
    ];
    this.calcNoticeWeight();
    this.levelNotification =
      store.getters[types.GETTER_SETTING_DATA] &&
      store.getters[types.GETTER_SETTING_DATA].level_notification
        ? store.getters[types.GETTER_SETTING_DATA].level_notification
        : {
            first_interval: 120,
            day_times: [32400, 75600]
          };
    const is_send_notice_before = localStorage.getItem("is_send_notice_before");
    //当前时刻的时间戳
    const nowTime = new Date().getTime();
    //当天零点的时间戳
    const todayZero = new Date(new Date().toLocaleDateString()).getTime();
    //距离当天24点的时间戳
    const leftTime = todayZero + 24 * 3600 * 1000 - nowTime;
    const day_times_List = this.levelNotification.day_times;
    const registTwoDayNotice = () => {
      for (let i = 0; i < 1; i++) {
        for (let j = 0, lens = day_times_List.length; j < lens; j++) {
          const timeInter = leftTime + day_times_List[j] * 1000;
          const data = timeInter ? this.getNoticePushData(timeInter) : "";
          if (data !== "") {
            sendToNativeData += "&" + JSON.stringify(data);
          }
        }
      }
    };
    let sendToNativeData = "";
    if (is_send_notice_before === undefined) {
      const timeInterval = this.levelNotification.first_interval * 1000; //第一次发通知，第一天只发一条，第一条消息退出后台N秒后就发
      const pushData = timeInterval ? this.getNoticePushData(timeInterval) : "";
      if (pushData !== "") {
        sendToNativeData = "&" + JSON.stringify(pushData);
      }
      localStorage.setItem("is_send_notice_before", JSON.stringify(true));
      //注册第二天的消息
      registTwoDayNotice();
    } else {
      //之前有发过通知，注册今天与第二天
      //注册今天的通知
      for (const time of day_times_List) {
        if (nowTime < todayZero + time * 1000) {
          const timeval = todayZero + time * 1000 - nowTime;
          const datapush = this.getNoticePushData(timeval);
          if (datapush !== "") {
            sendToNativeData += "&" + JSON.stringify(datapush);
          }
        }
      }
      //注册第二天的消息
      registTwoDayNotice();
    }
    return sendToNativeData;
  };

  //计算池子里通知的权重
  private calcNoticeWeight = () => {
    this.totalWeight = 0;
    for (const val of this.needRandomNoticeList) {
      val.min = this.totalWeight;
      val.max = this.totalWeight + val.weight;
      this.totalWeight = val.max;
    }
  };
  //随机消息的类别
  private randomNoticeContent() {
    const randomNum = Math.floor(Math.random() * this.totalWeight);
    let noticeItem;
    for (let i = 0, len = this.needRandomNoticeList.length; i < len; i++) {
      if (
        this.needRandomNoticeList[i].min <= randomNum &&
        this.needRandomNoticeList[i].max > randomNum
      ) {
        noticeItem = this.needRandomNoticeList[i].notice;
        //当前通知随机到后，就从池子里删除，并且重新计算总的权重
        this.needRandomNoticeList.splice(i, 1);
        this.calcNoticeWeight();
        return noticeItem;
      }
    }
  }
  /*
   *发送的消息内容
   * @param val 必填  延迟的时间
   */
  private getNoticePushData(val: number) {
    timetest += 3000;
    //消息对象
    const noticeArr: any = this.randomNoticeContent();
    if (!noticeArr) {
      return "";
    }
    //随机消息的下标
    const num = Math.floor(Math.random() * noticeArr.length);
    const pushData = {
      title: noticeArr[num].title,
      content: noticeArr[num].text,
      customData: noticeArr[num].customData,
      timeInterval: val,
      imageUrl: noticeArr[num].icon
    };
    return pushData;
  }
}

const getNoticeContent = new GetNoticeContent();
export default getNoticeContent;
